module.exports = __webpack_public_path__ + "fonts/unknown-device.11e8ebbae8b1016671155b10d6f0a803.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/security/unknown-device.png
// module id = 792
// module chunks = 9